import { HttpService } from '@/services/http.service';

export default {
    async store() {
        return await HttpService.httpPost(`/landing`);
    },
}
